import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import ReactIframeResizer from 'react-iframe-resizer-super';
import AdPerformanceStats from './AdPerformanceStats';
import { Spinner } from 'components';
import * as styles from './SocialMediaSummary.scss';

var cheerio = require('cheerio');

var AdPerformancePreview = /*#__PURE__*/function (_Component) {
  _inherits(AdPerformancePreview, _Component);

  var _super = _createSuper(AdPerformancePreview);

  function AdPerformancePreview() {
    var _this;

    _classCallCheck(this, AdPerformancePreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderIframe", function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          justifyContent: 'space-around'
        }
      }, item.iframeSrc ? /*#__PURE__*/React.createElement("img", {
        style: {
          maxWidth: 502,
          width: '100%',
          height: '100%'
        },
        src: item.iframeSrc
      }) : /*#__PURE__*/React.createElement(Spinner, null));
    });

    return _this;
  }

  _createClass(AdPerformancePreview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          section = _this$props.section,
          loading = _this$props.loading;
      return !loading ? /*#__PURE__*/React.createElement("div", null, items.length ? items.map(function (item, index) {
        var daterange = "".concat(moment(item.data.campaign.start_time).format('M/DD/YY'), " - ").concat(moment(item.data.campaign.stop_time).format('M/DD/YY'));
        return /*#__PURE__*/React.createElement("div", {
          key: "adPerformance_".concat(index),
          className: [styles.wrap, index === 0 || index % 2 === 0 || index === items.length - 1 ? styles.itemPageBreak : null].filter(function (s) {
            return s;
          }).join(' ')
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.column
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.adtitle
        }, item.data.name.slice(0, 4) === 'act_' ? 'Promoted Post' : item.data.name), /*#__PURE__*/React.createElement("span", {
          className: styles.addateRange
        }, daterange), /*#__PURE__*/React.createElement(AdPerformanceStats, {
          adDetails: item.data
        })), /*#__PURE__*/React.createElement("div", {
          className: styles.column
        }, item && _this2.renderIframe(item, index)));
      }) : /*#__PURE__*/React.createElement("span", null, "No ads for date range selected.")) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);

  return AdPerformancePreview;
}(Component);

export { AdPerformancePreview as default };